import { faCheck, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Dialog = ({ visible, onHide, type, message }) => {
  const { t } = useTranslation();
  return (
    <Modal centered show={visible} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {type === 1 ? (
            <FontAwesomeIcon icon={faCheck} size="lg" color="green" />
          ) : (
            <FontAwesomeIcon icon={faExclamationTriangle} size="lg" color="red" />
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-primary" onClick={onHide}>
          {t("ok")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Dialog;
